import { render, staticRenderFns } from "./kingdomz.vue?vue&type=template&id=b3cffe50"
import script from "./kingdomz.vue?vue&type=script&lang=js"
export * from "./kingdomz.vue?vue&type=script&lang=js"
import style0 from "./kingdomz.vue?vue&type=style&index=0&id=b3cffe50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports